import { render, staticRenderFns } from "./mes.vue?vue&type=template&id=027f3d51&scoped=true"
import script from "./mes.vue?vue&type=script&lang=js"
export * from "./mes.vue?vue&type=script&lang=js"
import style0 from "./mes.vue?vue&type=style&index=0&id=027f3d51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027f3d51",
  null
  
)

export default component.exports